import Vue from 'vue';
import vSelect from 'vue-select';
import VxTooltip from './components/vx-tooltip/VxTooltip.vue';
import VxCard from './components/vx-card/VxCard.vue';
import VxList from './components/vx-list/VxList.vue';
import VxBreadcrumb from './components/VxBreadcrumb.vue';
import FeatherIcon from './components/FeatherIcon.vue';
import VxInputGroup from './components/vx-input-group/VxInputGroup.vue';

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VxInputGroup.name, VxInputGroup);

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) =>
      createElement('feather-icon', {
        props: {
          icon: 'XIcon',
          svgClasses: 'w-4 h-4 mt-1'
        }
      })
  },
  OpenIndicator: {
    render: (createElement) =>
      createElement('feather-icon', {
        props: {
          icon: 'ChevronDownIcon',
          svgClasses: 'w-5 h-5'
        }
      })
  }
});

// v-select component
Vue.component(vSelect);

// global mixin
Vue.mixin({
  methods: {
    $showErrorNotification(error, { throwError = false, customMessage = '', showNotification = true } = {}) {
      if (showNotification && (error.response.data.message || customMessage)) {
        this.$vs.notify({
          title: 'error',
          text: customMessage ? customMessage : error.response.data.message,
          color: 'danger',
          time: 4500
        });
        console.error(customMessage ? customMessage : error.response.data.message);
      }

      if (process.env.NODE_ENV !== 'production' && throwError) {
        throw error;
      }
    }
  }
});
